
import mixins from "vue-typed-mixins";
import UserMixin from "@/mixins/UserMixin";
import { NavigationOptions } from "@/mixins/types";

export default mixins(UserMixin).extend({
  name: 'NavigationDrawer',
  data: () => ({
    navOptions: <NavigationOptions[]>[]
  }),
  computed: {
    navBtnClass(){
      return this.isCustomer ? 'pt-0' : '';
    },
    navTitle(): string{
      return this.isLandingPage ? 'Welcome! &#128513;' : `Hi ${this.userFirstName ?? 'User'} &#128075;`
    },
    isLandingPage(){
      return this.$route.name === 'Landing';
    }
  },
  methods: {
    closeNavDrawer(){
      this.$emit('closeNavDrawer');
    },
    reroute(routeName: string){
      this.closeNavDrawer();
      this.$router.push({name: routeName});
    },
    navOptionPressed(option: NavigationOptions){
      if(option.type === 'href') window.location.href = option.value;
      if(option.type === 'reroute') this.reroute(option.value);
    }
  },
  mounted(){
    const routeName = this.$route.name;
    if(routeName === 'Landing'){
      this.navOptions = [
        {label: 'Home', value: '#home', type: 'href'},
        {label: 'Features', value: '#features', type: 'href'},
        {label: 'Pricing', value: '#pricing', type: 'href'}
      ] as NavigationOptions[]
      return;
    }
    const options: NavigationOptions[] = [];
    if(this.isCustomer){
      const opts = <NavigationOptions[]>[
        {label: 'My Barrels', value: 'MyBarrels', type: 'reroute'}
      ];
      opts.forEach(opt => options.push(opt));
    }

    if(this.isStaff){
      const opts = <NavigationOptions[]>[
        {label: 'Manage Barrels', value: 'Admin', type: 'reroute'}
      ];
      opts.forEach(opt => options.push(opt));
    }

    this.navOptions = options
  }
})
